import styled from "styled-components"

export const AssociationStyle = styled.div`
  .detail-box {
    background: #fff;
    border-radius: 10px;
    padding: 8px 32px;
    height: 330px;
  }
`
